import React, { Component } from 'react';
import { Form, Input, Button, Checkbox, Icon, message } from 'antd';
import userStorage from '../../utils/storage';
import FormItem from '../../components/FormItem/index';
import { login } from '../../services/api';
import './index.less';
const formItems = [
  {
    name: 'username',
    options: {
      rules: [{ required: true, message: 'Please input your username!' }]
    },
    component: (
      <Input
        prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
        placeholder="username"
      />
    )
  },
  {
    name: 'password',
    options: {
      rules: [{ required: true, message: 'Please input your Password!' }]
    },
    component: (
      <Input
        prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />}
        type="password"
        placeholder="Password"
      />
    )
  },
  {
    name: 'remember',
    options: {
      valuePropName: 'checked',
      initialValue: true
    },
    component: <Checkbox>Remember me</Checkbox>
  }
];
class Login extends Component {
  constructor() {
    super();
  }
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        login(values).then(data => {
          if (data.code === 0) {
            userStorage.token = data.token;
            userStorage.userInfo = {
              username: data.username,
              right_level: data.right_level
            };
            this.props.history.push('/');
          } else {
            message.error(data.msg);
          }
        });
      }
    });
  };

  render() {
    return (
      <div className="login-area">
        <Form onSubmit={this.handleSubmit} className="login-form">
          {formItems.map((item, key) => {
            return <FormItem key={key} form={this.props.form} item={item} />;
          })}
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            Log in
          </Button>
        </Form>
      </div>
    );
  }
}

export default Form.create()(Login);
